import { render, staticRenderFns } from "./cg-event-links.vue?vue&type=template&id=3e707e9a&scoped=true"
import script from "./cg-event-links.vue?vue&type=script&lang=js"
export * from "./cg-event-links.vue?vue&type=script&lang=js"
import style0 from "./cg-event-links.vue?vue&type=style&index=0&id=3e707e9a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3e707e9a",
  null
  
)

export default component.exports